import { Modal } from 'ui';

import { FundraisingDescriptionForm } from '../../../molecules';
import { EditPeerPageModalFooter } from './EditPeerPageModalFooter';
import {
  ModalTitleWithBackButton,
  useEditPeerPageModalProvider,
} from './EditPeerPageModalProvider';

const EditFundraisingDescriptionModal = () => {
  const { opened, close, meta } = useEditPeerPageModalProvider({
    id: 'description',
  });

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={<ModalTitleWithBackButton>Fundraising Description</ModalTitleWithBackButton>}
    >
      <FundraisingDescriptionForm initialValue={meta.peer.description} />
      <EditPeerPageModalFooter />
    </Modal>
  );
};

export { EditFundraisingDescriptionModal };
